import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort } from '@angular/material';
import { NotificationDataSource } from './notification-datasource';
import { NotificationService } from '../services/notification.service';
import { Globals } from 'src/app/shared/services/globals';

@Component({
  selector: 'app-notification-view',
  templateUrl: './notification-view.component.html',
  styleUrls: ['./notification-view.component.css']
})
export class NotificationViewComponent implements OnInit {
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort: MatSort;
  dataSource: NotificationDataSource;
  displayedColumns = ["id",'message','readed' ,'action'];
  constructor(private notificationService: NotificationService, public globals: Globals) { }
  ngOnInit() {
    this.dataSource = new NotificationDataSource(this.paginator, this.sort, this.notificationService);

     //
  }

  applyFilter(filterValue: any) {
    this.dataSource.filter(filterValue.toString().trim().toLowerCase(), this.displayedColumns);
    this.dataSource = new NotificationDataSource(this.paginator, this.sort, this.notificationService);

  }

  ngOnDestroy()
  {
    this.dataSource.Destroy();
  }

}
